export default {
    bind(el) {
        el.__pendingUploads__ = [];
    },
    inserted(el, args, { context }) {
        if(el.tagName !== 'FORM') {
            console.error("v-pending : element must be a <form>");
            return;
        }
        let submitButton = el.querySelector('button[type="submit"]');
        let submitButtonOriginalTextContent = submitButton.textContent;
        if(!submitButton) {
            console.error("v-pending : can't find submit button");
            return;
        }

        el.addEventListener('submit',e=>{
            if(el.__pendingUploads__.length) {
                e.preventDefault();
            }
        });

        let watchSubmitComponents = $children => {
            $children && $children.forEach($child=>{
                if($child.$children) {
                    watchSubmitComponents($child.$children);
                }
                if($child.$options.name === 'Upload') {
                    console.log('upload comp',$child);
                    $child.$watch('pending', pending=>{
                        if(pending) {
                            el.__pendingUploads__.push($child._uid);
                        }
                        else {
                            el.__pendingUploads__ = el.__pendingUploads__.filter(id => id !== $child._uid);
                        }
                        let allPending = !!el.__pendingUploads__.length;
                        submitButton.disabled = allPending;
                        submitButton.textContent = allPending ? 'Téléchargement...' : submitButtonOriginalTextContent;
                    });
                }
            });
        };

        watchSubmitComponents(context.$children);
    },
    update(el) {

    }
}